// ConnectionStatusBar is disabled

/**
 * Debug Connection Status Bar
 * 
 * Shows connection status at the top of every screen
 * For testing purposes only
 */
/**
 * ConnectionStatusBar is completely disabled
 * We're using the debug panel at the bottom of the screen instead
 */
const ConnectionStatusBar = () => {
  // Don't show this component at all - we have a better debug panel at the bottom
  return null;
};

export default ConnectionStatusBar;
